module.exports = __webpack_public_path__ + "img/cayka-thumbnails.383baccb.png";